import React from 'react'
import "./styles/selectboard.css"

function DeleteMsg() {
  return (
    <div className='ss'>
        <div className='addedtask-container'>
            <p>Board deleted successfully</p>
        </div>
    </div>
  )
}

export default DeleteMsg